export const REQUEST_SERVICE_ESTIMATE = 'REQUEST_SERVICE_ESTIMATE';

export function requestServiceEstimate() {
  return {type: REQUEST_SERVICE_ESTIMATE};
}

export const RECEIVE_SERVICE_ESTIMATE = 'RECEIVE_SERVICE_ESTIMATE';

export function receiveServiceEstimate(agencyId, serviceId, serviceEstimate) {
  return {type: RECEIVE_SERVICE_ESTIMATE, agencyId, serviceId, serviceEstimate};
}

export const SET_SERVICE_ESTIMATE_TIMEOUT = 'SET_SERVICE_ESTIMATE_TIMEOUT';

export function setServiceEstimateTimeout(timeout) {
  return {type: SET_SERVICE_ESTIMATE_TIMEOUT, timeout};
}

export const UNSET_SERVICE_ESTIMATE_TIMEOUT = 'UNSET_SERVICE_ESTIMATE_TIMEOUT';

export function unsetServiceEstimateTimeout() {
  return {type: UNSET_SERVICE_ESTIMATE_TIMEOUT};
}

export function clearServiceEstimateTimeout(timeout) {
  return dispatch => {
    clearTimeout(timeout);
    dispatch(unsetServiceEstimateTimeout(timeout));
  };
}

export function fetchServiceEstimate(agencyId, serviceId) {
  return (dispatch, getState, {api}) => {
    dispatch(requestServiceEstimate());
    return api.fetchServiceEstimate({agencyId, serviceId, state: getState()}).then(response => {
      switch (response.status) {
        case 200:
          return response
            .json()
            .then(serviceEstimate => dispatch(
              receiveServiceEstimate(agencyId, serviceId, serviceEstimate)
            ));
        case 400:
          return dispatch(receiveServiceEstimate(agencyId, serviceId, null));
        case 422:
          return dispatch(receiveServiceEstimate(agencyId, serviceId, null));
        default:
          throw response;
      }
    });
  };
}

export function pollServiceEstimate(agencyId, serviceId) {
  return (dispatch, getState) => {
    const {timeout} = getState().serviceEstimate;
    if (timeout !== null) {
      dispatch(clearServiceEstimateTimeout(timeout));
    }
    dispatch(fetchServiceEstimate(agencyId, serviceId)).then(() => {
      dispatch(
        setServiceEstimateTimeout(
          setTimeout(
            () => {
              dispatch(pollServiceEstimate(agencyId, serviceId));
            },
            5000,
          ),
        ),
      );
    });
  };
}

export function cancelServiceEstimate() {
  return (dispatch, getState) => {
    const {timeout} = getState().serviceEstimate;
    if (timeout !== null) {
      dispatch(clearServiceEstimateTimeout(timeout));
    }
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/serviceEstimate.js